module.exports = "<div class=\"ibox-tools\" dropdown>\r\n  <a class=\"collapse-link\" (click)=\"collapse($event)\">\r\n    <i class=\"fa fa-chevron-up\"></i>\r\n  </a>\r\n  <a dropdownToggle>\r\n    <i class=\"fa fa-wrench\"></i>\r\n  </a>\r\n  <ul class=\"dropdown-menu dropdown-user\" *dropdownMenu>\r\n    <li><a href=\"#\">Config option 1</a>\r\n    </li>\r\n    <li><a href=\"#\">Config option 2</a>\r\n    </li>\r\n  </ul>\r\n  <a class=\"close-link\" (click)=\"close($event)\">\r\n    <i class=\"fa fa-times\"></i>\r\n  </a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/iboxtools/iboxtools.template.html
// module id = 1088
// module chunks = 0